module.exports = __webpack_public_path__ + "static/img/ranking_empty.3852ce8.png";